export default class NewResponseError extends Error {
  constructor(code, body) {
    super(body)
    this.code = code
    this.body = body
  }
}
